import type { IWatchlistable } from 'src/components/filmwebid/withWatchlistState';
import WatchlistSvg from 'src/components/svg/WatchlistSvg';
import classNames from 'classnames';
import styles from './WatchlistButton.module.css';
import { locale } from "@locale";

//#region [Styles]
// Converted to CSS Modules (WatchlistButton.module.css)
//#endregion

//#region [Props]
type WatchlistButtonProps = {
    className?: string;
} & IWatchlistable;
//#endregion

//#region [Component]
export default function WatchlistButton({ isWatchlisted, onWatchlistClick, className }: WatchlistButtonProps) {
    return <button onClick={onWatchlistClick} className={classNames(styles.SButton, className)} aria-label={locale.watchlist.addToWatchlist}>
        <WatchlistSvg className={styles.SWatchlistIcon} selected={isWatchlisted} />
    </button>;
}
//#endregion
